import { Chess, ChessInstance, Move, PieceType } from "chess.js";
import { achievements } from "./achievements";
export class VisionPosition {
  game: ChessInstance;
  moves: Move[];
  checks: Move[];
  captures: Move[];
  playerPieceCount: number = 0;

  // After a player has made a move, the following properties are set:
  moveType: "check" | "capture" = "check";
  validMoves: Move[] = [];
  playedMoves: Move[] = [];
  elapsed: number = 0;

  constructor(fen: string) {
    this.game = new Chess(fen);
    this.moves = this.game.moves({ verbose: true });
    this.checks = this.moves.filter((m) =>
      m.san.at(-1) === "+" || m.san.at(-1) === "#"
    );
    this.captures = this.moves.filter((m) => m.captured);
    this.playerPieceCount =
      this.game.board().flat().filter((p) => p?.color === this.game.turn())
        .length;
  }

  play(moveType: "check" | "capture", moves: string[], elapsed: number) {
    this.moveType = moveType;
    this.validMoves = moveType === "check" ? this.checks : this.captures;
    this.playedMoves = this.validMoves.filter((m) => moves.includes(m.san));
    this.elapsed = elapsed;
  }

  // Return the list of achievements that match the given position, along with
  // whether or not the user has achieved them given the list of moves they
  // have played.
  get achievements() {
    return achievements
      .filter((a) => a.match(this.validMoves))
      .map((a) => ({
        id: a.id,
        title: a.title,
        description: a.description,
        achieved: a.match(this.playedMoves),
      }));
  }
}
